import React from 'react';
import { useMetabaseUrl } from '../hooks/useConfig';
import { ExclamationCircleIcon, ArrowPathIcon } from '@heroicons/react/24/outline';

const DashboardPage: React.FC = () => {  
  const { data: metabaseUrl, isLoading, error } = useMetabaseUrl();

  if (isLoading) {
    return (
      <div className="h-full flex flex-col items-center justify-center bg-white dark:bg-zinc-800 rounded-lg shadow-lg border border-zinc-200 dark:border-zinc-700">
        <ArrowPathIcon className="h-8 w-8 animate-spin text-blue-500 mb-4" />
        <p className="text-zinc-600 dark:text-zinc-300">Carregando dashboard...</p>
      </div>
    );
  }

  if (error || !metabaseUrl) {
    return (
      <div className="h-full flex flex-col items-center justify-center bg-white dark:bg-zinc-800 rounded-lg shadow-lg border border-zinc-200 dark:border-zinc-700">
        <div className="text-center max-w-md">
          <ExclamationCircleIcon className="h-16 w-16 text-rose-500 mx-auto mb-4" />
          <h3 className="text-lg font-semibold text-zinc-900 dark:text-white mb-2">
            Erro ao carregar dashboard
          </h3>
          <p className="text-zinc-600 dark:text-zinc-300 text-sm mb-4">
            {error instanceof Error ? error.message : 'URL da tela inicial não configurada'}
          </p>
          <p className="text-xs text-zinc-500 dark:text-zinc-400">
            Configure em <span className="font-mono">/organizacao#parametros</span> ou peça ao administrador.
          </p>
        </div>
      </div>
    );
  }

  return (
    <div className="h-full flex flex-col">
      <div className="flex-1 bg-white dark:bg-zinc-800 rounded-lg shadow-lg border border-zinc-200 dark:border-zinc-700 overflow-hidden">
        <iframe
          title="Tela inicial"
          src={metabaseUrl}
          className="h-full w-full"
          style={{ border: 'none' }}
          loading="lazy"
        />
      </div>
    </div>
  );
};

export default DashboardPage;